<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <v-card>
          <!-- <v-card-title class="bx-5">
            <v-btn block color="red darken-1 white--text">Delete All</v-btn>
          </v-card-title> -->

          <v-data-table
            :headers="headers"
            :items="Transactions"
            :search="search"
            :loading="searching"
            :items-per-page="itemPerPage"
          >
            <template v-slot:item.Ref="{ item }">
              <template>
                <p
                  class="d-print-none my-auto success--text"
                  text
                  color="success"
                >
                  {{ item.Ref }}
                </p>
              </template>
            </template>
            <template v-slot:item.date="{ item }">
              {{ item.date }}
            </template>
            <template v-slot:item.Details="{ item }">
              {{ item.Reason || item.Details }}
            </template>
            <template v-slot:item.FullName="{ item }">
              {{ item.FullName || item.Description }}
            </template>
            <template v-slot:item.In="{ item }">
              <template v-if="item.Acc == 'Dr'">
                {{ Math.abs(item.Amount).toLocaleString() }}
              </template>
            </template>
            <template v-slot:item.Out="{ item }">
              <template v-if="item.Acc == 'Cr'">
                {{ Math.abs(item.Amount).toLocaleString() }}
              </template>
            </template>
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Deleting Transactions</v-toolbar-title>

                <v-divider class="mx-4" inset vertical></v-divider>
                <div class="flex-grow-1"></div>
                <v-dialog v-model="dialog" max-width="500px" persistent>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      color="primary"
                      dark
                      class="mb-2 d-print-none"
                      v-on="on"
                      >Search</v-btn
                    >
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Search Transaction</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-form ref="form" class="mx-5">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                :loading="searching"
                                :disabled="searching"
                                v-model="refID"
                                :rules="[
                                  v => !!v || 'Transaction Ref is required',
                                ]"
                                required
                                name="RefID"
                                label="Transaction Ref"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn
                        color="blue darken-1"
                        :disabled="searching"
                        text
                        @click="close"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        :loading="searching"
                        text
                        @click="OnSearch"
                        >Search</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col>
        <v-btn
          @click="OnDelete"
          :loading="isloading"
          v-if="Transactions.length"
          block
          color="red white--text"
          >Delete all</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      itemPerPage: 10,
      isloading: false,
      searching: false,
      search: "",
      refID: "",
      headers: [
        {
          text: "Date",
          align: "left",
          value: "date",
          class: "teal lighten-1 white--text",
        },
        {
          text: "Reason",
          value: "FullName",
          class: "teal lighten-1 white--text",
        },
        {
          text: "Details",
          value: "Details",
          class: "teal lighten-1 white--text",
        },
        {
          text: "Account",
          value: "AccountName",
          class: "teal lighten-1 white--text",
        },
        { text: "In", value: "In", class: "teal lighten-1 white--text" },
        {
          text: "Out",
          value: "Out",
          // class: "blue--text",
          class: "teal lighten-1 white--text",
        },
        {
          text: "User",
          value: "UserName",
          class: "teal lighten-1 white--text",
        },
        {
          text: "Ref",
          value: "Ref",
          class: "d-print-none teal lighten-1 white--text",
          // class: "indigo lighten-1 white--text"
        },
      ],
      Transactions: [],
      dialog: false,
    };
  },
  methods: {
    TranSactionsRep(RefID) {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: "/Reports/deleteRef",
        query: {
          RefID,
        },
      });
    },

    close() {
      this.dialog = false;
    },
    OnSearch() {
      if (this.$refs.form.validate()) {
        this.Transactions = [];

        this.searching = true;
        this.isloading = true;
        this.$store;
        this.TranSactionsRep(this.refID)
          .then(result => {
            //   console.log(result);
            this.Transactions = result.data;
            this.searching = false;
            this.isloading = false;
            if (this.Transactions.length) this.close();
          })
          .catch(() => {
            // console.log(error);
            this.searching = false;
            this.isloading = false;
          });
      }
    },
    OnDelete() {
      this.isloading = true;
      this.$store
        .dispatch("INSERT_ONLY", {
          url: "/Reports/deleteRef",
          data: {
            RefID: this.Transactions[0].Ref,
          },
        })
        .then(result => {
          this.isloading = false;
          if (result.status == 201) this.Transactions = [];
        })
        .catch(() => {
          this.isloading = false;
        });
    },
  },
};
</script>
